import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faArrowsRotate } from '@/fontawesome';

interface ErrorStateProps {
  message: string;
  /** Renders a retry button - pass the resource's `reload()`. */
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export default function ErrorState({
  message,
  onRetry,
  retryLabel = 'Erneut versuchen',
  className = '',
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={`bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 flex flex-wrap items-center justify-between gap-3 ${className}`}
    >
      <p className="text-red-600 dark:text-red-400 flex items-center gap-2 min-w-0">
        <FontAwesomeIcon icon={faTriangleExclamation} className="w-4 h-4 shrink-0" />
        <span>{message}</span>
      </p>
      {onRetry !== undefined && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg bg-red-600 hover:bg-red-700 text-white transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900"
        >
          <FontAwesomeIcon icon={faArrowsRotate} className="w-4 h-4" />
          {retryLabel}
        </button>
      )}
    </div>
  );
}
